__turbopack_context__.v({
  "activitiesTaxReturn": "TaxReturnActivityLogDialog-module__tu7ocG__activitiesTaxReturn",
  "activitiesTaxReturn__separator": "TaxReturnActivityLogDialog-module__tu7ocG__activitiesTaxReturn__separator",
});
